import api from './api';

interface ComplementoData {
  complemento_obrigatorio: boolean;
  descricao: string;
  qtd_min: number;
  qtd_max: number;
  tipo: number;
  empresa_id: number;
}

interface ItemComplementoData {
  codigo_complemento?: string;
  descricao: string;
  tipo: number;
  preco: number;
  imagem?: File;
  produto_id?: number;
  index_complemento: number;
  qtd_min?: number;
  qtd_max?: number;
}

interface ArrayItemComplementoRequest {
  codigo_complemento?: string;
  descricao: string;
  tipo: number;
  produto_id?: number;
}

const newComplemento = async (
  complementos: ComplementoData[],
  itens: ItemComplementoData[],
  grupo_produto_id: number,
  empresa_id: number,
): Promise<void> => {
  const dataForm = new FormData();
  const requestArray: ArrayItemComplementoRequest[] = [];

  itens.map((item) => {
    const requestObj = {
      codigo_complemento: item.codigo_complemento,
      descricao: item.descricao,
      tipo: item.tipo,
      nome_imagem: item.imagem ? item.imagem.name : undefined,
      produto_id: item.produto_id ? item.produto_id : undefined,
      index_complemento: item.index_complemento,
      preco: item.preco,
      qtd_min: item.qtd_min,
      qtd_max: item.qtd_max,
      empresa_id,
    };

    requestArray.push(requestObj);
    item.imagem && dataForm.append('item_complemento_img', item.imagem);
  });

  dataForm.append('itens_complemento', JSON.stringify(requestArray));
  dataForm.append('complementos', JSON.stringify(complementos));
  dataForm.append('grupo_produto_id', grupo_produto_id.toString());

  await api.post('/complemento', dataForm, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default newComplemento;
